import React from "react";
import { NavLink } from "react-router-dom";

// @ts-ignore
import logo from "../../assets/images/logo-light.svg";
import { toggleSidebarMobile } from "../../utils/sidebarUtils";

const handleSidebarItemClick = () => {
  const sidebar = document.querySelector(".account-sidebar.active");
  if (sidebar) {
    sidebar.classList.remove("active");
  }
};

export const Sidebar = () => {
  return (
    <div className="account-sidebar">
      <div className="closeMobileSidebarButton" onClick={toggleSidebarMobile}>
        <i className="fas fa-times"></i>
      </div>
      <div className="inner">
        <div className="logo-wrapper">
          <img alt="logo" className="logo" src={logo} />
        </div>

        <div className="sidebar-content">
          {/* Sidebar menu */}
          <ul className="items-wrapper">
            {/* <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/dashboard"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-chart-simple"></i>
                <span>Dashboard</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/dashboard"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-house"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/site-settings"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-cog"></i>
                <span>Site Settings</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/blog-posts"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-newspaper"></i>
                <span>Blog posts</span>
              </NavLink>
            </li>

            {/* <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/components"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-paintbrush"></i>
                <span>Components</span>
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};
